/* eslint-disable react/react-in-jsx-scope */
/** PringXSoft 快速链接图标（Falcon Reports 同款底板 + 语义化 FA 符号） */
import imgCreateOrder from '../../assets/img/quick-links/create-order.png';
import imgEditOrder from '../../assets/img/quick-links/edit-order.png';
import imgQuotationList from '../../assets/img/quick-links/quotation-list.png';
import imgOrderList from '../../assets/img/quick-links/order-list.png';
import imgPerformance from '../../assets/img/quick-links/performance.png';
import imgStatistics from '../../assets/img/quick-links/statistics.png';
import imgCustomers from '../../assets/img/quick-links/customers.png';
import imgProducts from '../../assets/img/quick-links/products.png';
import imgUsersAdmin from '../../assets/img/quick-links/users-admin.png';
import imgApproval from '../../assets/img/quick-links/approval-records.png';
import imgRoleTemplate from '../../assets/img/quick-links/role-template.png';
import imgLoginLogs from '../../assets/img/quick-links/login-logs.png';
import { FiAlertCircle, FiAward, FiBarChart2, FiBox, FiBriefcase, FiClock, FiEdit3, FiFileText, FiGitPullRequest, FiHexagon, FiHome, FiLink, FiList, FiLock, FiPlusCircle, FiRepeat, FiShield, FiSunrise, FiUser, FiUserCheck, FiUsers } from 'react-icons/fi';
import { LuUserCog } from 'react-icons/lu';
import { DashboardQiuckButton as quickLinkButtonDefs, PERMISSION_GOVERNANCE_QUICK_LINKS as governanceQuickLinkDefs } from './quickLinkButtonDefs';

const QUICK_LINK_IMAGES = {
	create: imgCreateOrder,
	edit: imgEditOrder,
	quotation: imgQuotationList,
	orderList: imgOrderList,
	performance: imgPerformance,
	statistics: imgStatistics,
	customers: imgCustomers,
	products: imgProducts,
	users: imgUsersAdmin,
	approval: imgApproval,
	roleTemplate: imgRoleTemplate,
	loginLogs: imgLoginLogs,
};

const withQuickLinkImage = (button) => ({ ...button, img: QUICK_LINK_IMAGES[button.imageKey] });

export const DashboardQiuckButton = Object.fromEntries(Object.entries(quickLinkButtonDefs).map(([key, buttons]) => [key, buttons.map(withQuickLinkImage)]));

export const PERMISSION_GOVERNANCE_QUICK_LINKS = governanceQuickLinkDefs.map(withQuickLinkImage);

/** 按钮岛用矢量图标（按 link / title 匹配，与 img 入口解耦） */
export function getQuickLinkIconComponent(button) {
	const link = String(button?.link || '');
	const title = String(button?.title || '');

	if (link === '/dashboard' || title === '首页') {
		return FiHome;
	}
	if (link.includes('/order/create') || title.includes('新建订单')) {
		return FiPlusCircle;
	}
	if (link.includes('editlist') || title.includes('订单编辑')) {
		return FiEdit3;
	}
	if (link.includes('quotationlist') || title.includes('报价查询') || title.includes('报价单')) {
		return FiFileText;
	}
	if (link.includes('/approval/list') || title === '审批信息' || title.includes('审批记录') || title.includes('申请记录')) {
		return FiUserCheck;
	}
	if (link.includes('orderlist') || title.includes('订单查询')) {
		return FiList;
	}
	if (link.includes('performancerules') || title.includes('绩效管理')) {
		return FiAward;
	}
	if (link.includes('/statistics') || title.includes('业务统计')) {
		return FiBarChart2;
	}
	if (link.includes('productlist') || title.includes('产品信息')) {
		return FiBox;
	}
	if (link.includes('customerlist') || title.includes('客户信息')) {
		return FiUsers;
	}
	if (link === '/userlist' || title.includes('系统用户管理')) {
		return LuUserCog;
	}
	if (link.includes('role-permissions') || title.includes('角色权限')) {
		return FiShield;
	}
	if (link.includes('loginlogs') || title.includes('登录日志')) {
		return FiClock;
	}

	return FiLink;
}

export const DashboardAdminQiuckButton = {
	orderBtn: [
		{
			title: '新建订单',
			description: '进入新建订单页面',
			img: imgCreateOrder,
			link: '/sales/order/productList',
		},
		{
			title: '订单编辑',
			description: '进入订单列表页面',
			img: imgEditOrder,
			link: '/editlist',
		},
	],
	infoBtn: [
		{
			title: '客户信息',
			description: '您的所有客户信息显示',
			img: imgCustomers,
			link: '/customerlist',
		},
		{
			title: '厂家信息',
			description: '厂家信息维护',
			img: imgProducts,
		},
		{
			title: '用户信息',
			description: '您拥有此权限，可对用户信息进行维护',
			img: imgUsersAdmin,
		},
	],
};
export const DashboardSalesQiuckButton = {
	orderBtn: [
		{
			title: '新建订单',
			description: '进入新建订单页面',
			img: imgCreateOrder,
			link: '/sales/order/productList',
		},
		{
			title: '订单查询',
			description: '进入订单页面',
			img: imgOrderList,
			link: '/orderlist',
		},
	],
	infoBtn: [
		{
			title: '客户信息',
			description: '您的所有客户信息显示',
			img: imgCustomers,
		},
		{
			title: '厂家信息',
			description: '厂家信息维护',
			img: imgProducts,
		},
		{
			title: '用户信息',
			description: '您拥有此权限，可对用户信息进行维护',
			img: imgUsersAdmin,
		},
	],
};

export const team = [
	{
		icon: <FiUser className='text-primary fs-7' />,
		color: 'primary',
		title: 'Agents',
		description: "Define agents' scope of work, type, language, and other details.",
	},
	{
		icon: <FiUsers className='text-info fs-7' />,
		color: 'info',
		title: 'Groups',
		description: 'Agents can be organized and unattended tickets can be notified.',
	},
	{
		icon: <FiGitPullRequest className='text-warning fs-7' />,
		color: 'warning',
		title: 'Roles',
		description: 'Provide agents with fine-grained access and privileges.',
	},
	{
		icon: <FiClock className='text-success fs-7' />,
		color: 'success',
		title: 'Working Hours',
		description: 'To set client expectations, define operating hours and holidays.',
	},
	{
		icon: <FiBriefcase className='text-primary fs-7' />,
		color: 'primary',
		title: 'Skills',
		description: 'Assign kinds of tickets to agents based on their expertise.',
	},
	{
		icon: <FiRepeat className='text-info fs-7' />,
		color: 'info',
		title: 'Agent Changes',
		description: 'Create and manage agent schedules all in one spot.',
	},
];

export const account = [
	{
		icon: <FiUserCheck className='text-primary fs-7' />,
		color: 'primary',
		title: 'Account Information',
		description: 'View the status of your account as well as your invoice email address.',
	},
	{
		icon: <FiFileText className='text-info fs-7' />,
		color: 'info',
		title: 'Billing & Plans',
		description: 'Plan, add-ons, team size, and billing cycle are all under your control.',
	},
	{
		icon: <FiSunrise className='text-warning fs-7' />,
		color: 'warning',
		title: 'Passes for the day',
		description: 'Part-time agents can purchase on-demand licenses.',
	},
	{
		icon: <FiLock className='text-success fs-7' />,
		color: 'success',
		title: 'Security',
		description: 'Advanced SSO settings, password policy, and domain restriction.',
	},
	{
		icon: <FiHexagon className='text-primary fs-7' />,
		color: 'primary',
		title: 'Log of Audits',
		description: 'All of the changes made to your falcon Support tickets account.',
	},
	{
		icon: <FiAlertCircle className='text-info fs-7' />,
		color: 'info',
		title: 'Configure the Helpdesk',
		description: 'Your Falcon Support Tickets will be personalized.',
	},
];
